import React from 'react'
import { connect } from "react-redux";
import "../../styles/Empresa.css";
import { obtenerTipoTramite, getTipoTramite, desactivarTipoTramite, activarTipoTramite } from './TipoTramiteService';
import MensajeFlash from '../mensajeFlash/MensajeFlash';

import NavbarConfiguraciones from "../componentes/NavbarConfiguraciones.js";
import TablaItemsConfiguracion from "../componentes/tablas/TablaItemsConfiguracion.js";
import ModalEliminarConDetalles from "../componentes/modales/ModalEliminarConDetalles.js";
import ModalDetalleConfiguraciones from "../componentes/modales/ModalDetalleConfiguraciones.js";

class TiposTramites extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dialogTitle: "Registrar nuevo tipo de tramite",
            dialogType: "add",
            submitText: "Guardar",
            disabledInput: false,
            selectedTipoTramite: {
                nombre: "",
                cantidadFirmas: "",
                id: "",
            },
            tipoTramiteSeleccionado: null,
            nuevoTipoTramite: false,
            editarTipoTramite: false,
            verTipoTramite: false,
            eliminarTipoTramite: false,
            restaurar: false,

            mostrarMensajeFlash: false,
            mensajeFlash: "",
            mensajeFlashSeverity: "neutral",
            openPantallaCarga: false
        };

        this.modalRef = React.createRef();
        this.tablaRef = React.createRef();
        this.modalEliminarRef = React.createRef();
    }

    handleDialogRestaurar = (value) => {
        this.setState({
            restaurar: value
        });
    }

    handleOpenNuevoTipoTramite = () => {
        this.setState({ nuevoTipoTramite: true });
    }

    handleCloseNuevoTipoTramite = (mensaje = "", severity = "") => {
        this.tableRef.current.onQueryChange();
        if (mensaje != "") {
            this.setState({
                mostrarMensajeFlash: true,
                mensajeFlash: mensaje,
                mensajeFlashSeverity: severity
            });
        }
        this.setState({ nuevoTipoTramite: false })

    }

    handleEditarTipoTramite = (datos) => {
        this.props.history.push({
            pathname: '/configuracion/tipo-solicitud/edit',
            state: { tipoTramite: datos }
        })
    }

    handleCloseEditarTipoTramite = (mensaje = "", severity = "") => {
        if (mensaje != "") {
            this.setState({
                mostrarMensajeFlash: true,
                mensajeFlash: mensaje,
                mensajeFlashSeverity: severity
            });
        }
        this.setState({ editarTipoTramite: false })
        this.tableRef.current.onQueryChange();
    }


    handleDialogVerDatos = (estado, dato = null) => {
        this.setState({ verTipoTramite: estado, tipoTramiteSeleccionado: dato }, () => {
            if (estado && dato && this.modalRef) {
                this.modalRef.current.cargarDetalles(dato.id);
            }
        });
    };

    handleDialogEliminarTramite = (value, data = null) => {
        this.setState({
            eliminarTipoTramite: value,
            tipoTramiteSeleccionado: data
        });
    }

    handleDelete = () => {
        this.modalEliminarRef.cerrarModalConAnimacion()
        this.setState({ openPantallaCarga: true });
        let tipoTramiteSeleccionado = this.state.tipoTramiteSeleccionado
        desactivarTipoTramite(tipoTramiteSeleccionado.id).then(res => {
            this.setState({
                openPantallaCarga: false,
                mostrarMensajeFlash: true,
                mensajeFlash: res.mensaje,
                mensajeFlashSeverity: res.error ? 'error' : 'exito'
            });
            this.actualizarDatosTabla()
        })
    }

    handleRestore = () => {
        this.setState({
            openPantallaCarga: true,
            restaurar: false
        });
        activarTipoTramite(this.state.selectedTipoTramite.id).then(res => {
            this.setState({
                openPantallaCarga: false,
                open: false,
                mostrarMensajeFlash: true,
                mensajeFlash: res.mensaje,
                mensajeFlashSeverity: !res.error ? "success" : "danger"
            });
            this.tableRef.current.onQueryChange();
        })
    }

    fetchDocumentos = (page, pageSize, search) => {
        return this.props.getTipoTramite(page, pageSize, search).then(() => {
            const { tipoDocumentoData } = this.props;
            return {
                items: tipoDocumentoData.tipoDocumento,
                totalCount: tipoDocumentoData.totalCount,
            };
        });
    };

    renderFilas = (filas) => {
        return filas.map((f) => (
            <tr key={f.id}>
                <td>{f.nombre}</td>
                <td>{f.cantidadFirmas}</td>
                <td>
                    <div className="table-actions">
                        <button className="table-icon open-dialog" data-dialog="modal-detalle-documento"
                            data-id={f.id} onClick={() => this.handleDialogVerDatos(true, f)}>
                            <span className="material-symbols-outlined"> visibility </span>
                        </button>
                        <button className="table-icon" onClick={() => this.handleEditarTipoTramite(f)}>
                            <span className="material-symbols-outlined"> edit </span>
                        </button>
                        <button className="table-icon open-dialog" data-dialog="modal-delete-details" data-id={f.id}
                            onClick={() => this.handleDialogEliminarTramite(true, f)}>
                            <span className="material-symbols-outlined"> delete </span>
                        </button>
                    </div>
                </td>
            </tr>
        ));
    };

    actualizarDatosTabla = () => {
        if (this.tablaRef) {
            this.tablaRef.fetchData();
        }
    }

    render() {
        return (
            <div>
                <div className="template-base">
                    <NavbarConfiguraciones
                        titulo={"Tipos de solicitudes"}
                        descripcion={""}
                        textoBoton={"Agregar nuevo tipo solicitud"}
                        direccionBoton={"tipo-solicitud/nuevo"}
                    />
                    <div className="wrapperContent">
                        <div className="page-container">
                            <TablaItemsConfiguracion
                                ref={(ref) => (this.tablaRef = ref)}
                                titulo="Tipos de solicitudes disponibles"
                                headers={["Nombre", "Cantidad de firmas requeridas", "Acciones"]}
                                fetchDatos={this.fetchDocumentos}
                                renderFilas={this.renderFilas}
                            />
                        </div>
                    </div>
                    <ModalDetalleConfiguraciones
                        ref={this.modalRef}
                        abierto={this.state.verTipoTramite}
                        onClose={() => this.handleDialogVerDatos(false)}
                        fetchDetalle={obtenerTipoTramite}
                        titulo="Detalles del tipo trámite"
                        renderContenido={(datos) => (
                            <div className="card">
                                <div className="card-content">
                                    <div className="content-inner">
                                        <span className="label">Nombre del trámite</span>
                                        <span className="txt">{datos.tipoFormularioTramite.nombreFormulario}</span>
                                    </div>
                                    <div className="content-inner">
                                        <span className="label">Cantidad de firmas requeridas</span>
                                        <span className="txt">{datos.cantidadFirmas}</span>
                                    </div>
                                    <div className="content-inner">
                                        <span className="label">Acciones del colaborador</span>
                                        <span className="txt">{datos.accionesColaborador.nombre}</span>
                                    </div>
                                </div>
                            </div>
                        )} />
                </div>
                <MensajeFlash
                    visible={this.state.mostrarMensajeFlash}
                    mensaje={this.state.mensajeFlash}
                    severity={this.state.mensajeFlashSeverity} />


                <ModalEliminarConDetalles
                    ref={(ref) => (this.modalEliminarRef = ref)}
                    isOpen={this.state.eliminarTipoTramite}
                    cerrarModal={() => this.handleDialogEliminarTramite(false)}
                    onConfirmar={this.handleDelete}
                    elemento={this.state.tipoTramiteSeleccionado}
                    titulo="tipo de solicitud"
                    detallesAMostrar={[
                        { clave: 'nombre', etiqueta: 'nombre' },
                    ]}
                    mensaje="Esta acción eliminará el tipo de solicitud seleccionado."
                    textoBotonAccion="CONFIRMAR ELIMINACIÓN"
                />
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    getTipoTramite: (page, size, search) => dispatch(getTipoTramite(page, size, search)),
});

const mapStateToProps = (state) => ({
    tipoDocumentoData: state.tipoDocumentoData,
});


export default connect(mapStateToProps, mapDispatchToProps)(TiposTramites);